import { useNavigation } from '@speeki/client-admin';
import { useCheckFlag } from '@speeki/feature-flags';
import {
    Button,
    notify,
    TableEmptyState,
    Typography,
} from '@speeki/global-ui-components';

import { PlaceholderLayout } from '@components/templates/PlaceholderLayout';

import { CarbonLensInitializeSsoDocument } from '@graphql/generated/graphql.ts';

import { useMutation } from '@apollo/client';
import {
    EmptySpaceWrapper,
    MainWrapper,
} from '@pages/StaticPlaceholder.styled';

export const CarbonLensPlaceholder = () => {
    const { navigate } = useNavigation();

    const [carbonLensInitializeSso, { loading }] = useMutation(
        CarbonLensInitializeSsoDocument,
    );

    const isCarbonLensFeature = useCheckFlag(
        'client_admin-carbon_lens-20250401',
    );

    const handleClick = () => {
        carbonLensInitializeSso({
            onCompleted: (data) => {
                window.open(data.url, '_blank');
            },
            onError: (error) => {
                notify(error.message).ERROR();
            },
        });
    };

    if (!isCarbonLensFeature)
        return (
            <PlaceholderLayout
                headingOptions={{
                    icon: 'SvgEsgCalculator',
                    title: 'Carbon Lens',
                }}
            >
                <TableEmptyState
                    testId="szDeDMt"
                    title="Welcome to Carbon Lens"
                >
                    <EmptySpaceWrapper>
                        Carbon Lens is used for GHG emission accounting. This
                        feature is currently under development. Please check
                        back later.
                        <Button
                            center
                            onClick={() =>
                                navigate({
                                    path: '/dashboard',
                                })
                            }
                            testId="e2yumUP"
                            variant={'primary'}
                        >
                            Back to Homepage
                        </Button>
                    </EmptySpaceWrapper>
                </TableEmptyState>
            </PlaceholderLayout>
        );

    return (
        <PlaceholderLayout
            headingOptions={{
                icon: 'SvgEsgCalculator',
                title: 'Carbon Lens',
            }}
        >
            <TableEmptyState testId="szDeDMt" title={'Welcome to Carbon Lens'}>
                <EmptySpaceWrapper>
                    <MainWrapper>
                        <Typography.TextBody_16_24>
                            Carbon Lens supports your GHG accounting across
                            Scope 1, 2, and 3 emissions. <br /> With built-in
                            integration to Metric, it streamlines data capture
                            and simplifies carbon reporting.
                        </Typography.TextBody_16_24>
                    </MainWrapper>
                    <Button
                        center
                        isLoading={loading}
                        onClick={handleClick}
                        testId="e2yumUP"
                        variant={'primary'}
                    >
                        Go to carbon lens
                    </Button>
                </EmptySpaceWrapper>
            </TableEmptyState>
        </PlaceholderLayout>
    );
};
